import React, { Component } from 'react'
import {View, StyleSheet, Platform} from 'react-native'
import { JDText, JDImage, JDDevice, JDTouchable } from '@jdreact/jdreact-core-lib'

import PropTypes from "prop-types"

import arrowImg from '../../../images/detail/arrow-right.png'

// 标题的样式 titleName：定义标题名称；linkDes：跳转链接描述，若父组件不定义则没有；jump: 实现跳转
export default class SubTitle extends Component{
	static propTypes = {
		titleName: PropTypes.string,
		jump: PropTypes.func,
		linkDes: PropTypes.string,
		styleObj: PropTypes.object,
	};
	static defaultProps = {
		styleObj: {}
	}
	render() {
		const { styleObj } = this.props
		return (
			<View style={[sunTitleStyles.titleBox, styleObj]}>
				<JDText style={sunTitleStyles.titleName}>{this.props.titleName}</JDText>
				{
					this.props.linkDes ? (
						<JDTouchable style={sunTitleStyles.titleLink} onPress={this.props.jump}>
							<View style={sunTitleStyles.titleLinkCon}>
								<JDText style={sunTitleStyles.linkDes}>{this.props.linkDes}</JDText>
								<JDImage source={arrowImg} style={sunTitleStyles.arrow}></JDImage>
							</View>
						</JDTouchable>) : (null)
				}
			</View>
		)
	}
}
const sunTitleStyles = StyleSheet.create({
	titleBox: {
		flexDirection: 'row',
		alignItems: 'center',
		marginHorizontal: JDDevice.getRpx(30),
		marginVertical: JDDevice.getRpx(36),
		position: 'relative'
	},
	rod: {
		width: JDDevice.getRpx(6),
		height: JDDevice.getRpx(28),
		backgroundColor: '#424854',
		marginRight: JDDevice.getRpx(11),
		...Platform.select({
			android: {
				width: JDDevice.getRpx(8),
			}
		})
	},
	titleName: {
		fontSize: JDDevice.getFontSize(36),
		fontWeight: '500',
		color: '#1A1A1A',
		fontFamily: "PingFang SC"
	},
	titleLink: {
		position: 'absolute',
		right: 0
	},
	titleLinkCon: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-end'
	},
	linkDes: {
		fontSize: JDDevice.getFontSize(26),
		color: '#848689'
	},
	arrow: {
		width: JDDevice.getRpx(24),
		height: JDDevice.getRpx(24),
		marginLeft: JDDevice.getRpx(8),
		...Platform.select({
			android: {
				marginTop: JDDevice.getRpx(2)
			}
		})
	}
});
